<template>
  <div
    class="d-flex align-center flex-column justify-center pa-2 white"
    style="font-size: 30px; min-height: 80px"
    :style="cardStyles"
  >
    <template v-if="renderType === 'elefant'">
      <div class="text-center">
        <div
          v-if="text"
          style="font-family: dancing_script; font-size: 50px"
          class="text-center"
        >
          {{ text }}
        </div>
        <div v-if="date" class="text-body-1 text-center mt-n2">
          {{ date }}
        </div>
        <base-image
          :url="
            require('~/assets/images/product/individualisation/elefant_V2_2.jpg')
          "
          loading="lazy"
          :init-width="160"
          height="90px"
          width="160px"
        />
        <div
          v-if="size || weight"
          style="font-family: dancing_script; font-size: 50px"
          class="text-body-1 text-center mt-n2"
        >
          {{ weight }}
          {{ weight && size ? ' * ' : '' }}
          {{ size }}
        </div>
      </div>
    </template>
    <template v-else-if="renderType === 'fuesse'">
      <div>
        <div
          v-if="text"
          class="text-center"
          style="font-family: chewy_regular; font-size: 50px"
        >
          {{ text }}
        </div>
        <div style="min-width: 165px">
          <div
            v-if="date"
            class="text-body-1"
            style="font-family: bitter; font-size: 50px; margin-bottom: -25px"
          >
            {{ date }}
          </div>
          <base-image
            :url="
              require('~/assets/images/product/individualisation/fuesse.png')
            "
            loading="lazy"
            :init-height="180"
            height="180px"
            width="160px"
            style="margin-left: 16px"
          />
          <div
            v-if="size || weight"
            style="
              font-family: bitter;
              font-size: 50px;
              margin-top: -50px;
              padding-left: 110px;
            "
            class="text-body-1 text-left"
          >
            {{ weight }}
            <br />
            {{ size }}
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="renderType === 'herzen'">
      <div class="text-center">
        <base-image
          :url="require('~/assets/images/product/individualisation/herzen.jpg')"
          loading="lazy"
          :init-width="60"
          height="60px"
          width="60px"
        />
        <div
          v-if="text"
          style="font-family: atma; font-weight: 700; font-size: 50px"
          class="mt-n4"
        >
          {{ text }}
        </div>
        <div v-if="byNameText" style="font-family: atma; font-size: 23px">
          {{ byNameText }}
        </div>
      </div>
    </template>
    <template v-else-if="renderType === 'herzen_neu'">
      <div
        class="text-center"
        style="position: relative; height: 300px; overflow: hidden"
      >
        <base-image
          :url="
            require('~/assets/images/product/individualisation/herzen_neu.jpg')
          "
          loading="lazy"
          :init-width="260"
          width="260px"
          height="226px"
        />
        <div
          v-if="text"
          style="
            font-family: atma;
            font-weight: 700;
            font-size: 39px;
            position: absolute;
            top: 120px;
            left: 45px;
          "
        >
          {{ text }}
        </div>
        <div style="position: absolute; top: 205px; left: 105px; width: 170px">
          <div v-if="date" style="font-family: atma; font-size: 23px">
            {{ date }}
          </div>
          <div v-if="size || weight" style="font-family: atma; font-size: 23px">
            {{ weight }}
            {{ weight && size ? ' * ' : '' }}
            {{ size }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="text">
        {{ text }}
      </div>
      <div v-if="date">
        {{ date }}
      </div>
      <div v-if="time">
        {{ time }}
      </div>
      <div v-if="size || weight">
        {{ weight }}
        {{ weight && size ? ' * ' : '' }}
        {{ size }}
      </div>
    </template>
  </div>
</template>

<script>
import BaseImage from '~/components/base/image/BaseImage'
export default {
  name: 'ProductIndividualisationRenderCard',
  components: { BaseImage },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    renderType: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    text() {
      return this.findField('text')?.formattedValue
    },
    textTwo() {
      return this.findField('textTwo')?.formattedValue
    },
    textThree() {
      return this.findField('textThree')?.formattedValue
    },
    byNameText() {
      if (!this.textTwo) {
        return undefined
      }

      if (!this.textThree) {
        return `by ${this.textTwo}`
      }

      return `by ${this.textTwo} & ${this.textThree}`
    },
    date() {
      return this.findField('date')?.formattedValue
    },
    size() {
      return this.findField('size')?.formattedValue
    },
    weight() {
      return this.findField('weight')?.formattedValue
    },
    time() {
      return this.findField('time')?.formattedValue
    },
    color() {
      const color = this.findField('color')

      return color ? this.findFieldValue(color, 'color') : undefined
    },
    font() {
      const font = this.findField('font')

      return font ? this.findFieldValue(font, 'font') : undefined
    },
    cardStyles() {
      if (this.renderType !== 'default') {
        return {}
      }

      return {
        fontFamily: this.font ? this.font : 'lucida_handwriting',
        color: this.color ? this.color : undefined,
      }
    },
  },
  methods: {
    findField(fieldId) {
      return this.fields.find(({ id }) => id === fieldId)
    },
    findFieldValue(field, key) {
      return field.items.find(({ text }) => text === field.value)?.[key]
    },
  },
}
</script>

<style scoped>
@font-face {
  font-family: 'lucida_handwriting';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/lhandw-lucida-handwriting.woff2') format('truetype');
}

@font-face {
  font-family: 'script_mt_bold';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/ScriptMTBold.woff2') format('truetype');
}

@font-face {
  font-family: 'berlin_sans_fbregular';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/BerlinSansFBRegular.woff2') format('truetype');
}

@font-face {
  font-family: 'dancing_script';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/DancingScript-Regular.woff2') format('truetype');
}

@font-face {
  font-family: 'chewy_regular';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/Chewy-Regular.woff2') format('truetype');
}

@font-face {
  font-family: 'bitter';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/Bitter-Regular.woff2') format('truetype');
}

@font-face {
  font-family: 'atma';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('~assets/fonts/Atma.woff2') format('truetype');
}
</style>
